export const RANGE_DBAS = Object.freeze({
  LOW: `low`,
  LOW_FLAGGED: `lowFlagged`,
  HIGH: `high`,
})

export const BOUNDS_DBAS_RESULTS = Object.freeze({
  [RANGE_DBAS.LOW]: [`Low`],
  [RANGE_DBAS.LOW_FLAGGED]: [`Low flagged`],
  [RANGE_DBAS.HIGH]: [`High`],
})
